import AuthService from '../../AuthService';
const Faq = {
  getFaq(page){
    return AuthService.get(`faq/faq?page=${page}`);
  },
  showFaq(id){
    return AuthService.get(`faq/faq/${id}`);
  },
  createFaq(data){
    return AuthService.post(`faq/faq`,data);
  },
  updateFaq(id,data){
    return AuthService.put(`faq/faq/${id}`,data);
  },
  deleteFaq(id){
    return AuthService.delete(`faq/faq/${id}`);
  },
}
export default Faq
